import { Component, Input, OnInit } from '@angular/core';
import { BadgesByCategory, BadgesService, BadgesV2Query } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-badge-overview-list',
  templateUrl: './badge-overview-list.component.html',
  styleUrls: ['./badge-overview-list.component.scss'],
})
export class BadgeOverviewListComponent implements OnInit {
  isList: boolean = true;
  screenType = ScreenType;
  badgeByCategories$: Observable<BadgesByCategory[]>;
  @Input() confettiColors: string[];
  @Input() showPlaceholder: boolean = false;
  @Input() isSponsorInBody: boolean = false;
  @Input() showEarnedBadgesOnly: boolean = false;
  constructor(
    private badgesV2Query: BadgesV2Query,
    private badgesService: BadgesService
  ) {}

  ngOnInit(): void {
    firstValueFrom(this.badgesService.fetchBadgeV2(), { defaultValue: null });
    if (this.showEarnedBadgesOnly) {
      this.badgeByCategories$ = this.badgesV2Query.selectCompleted();
    } else {
      this.badgeByCategories$ = this.badgesV2Query.selectAllBadgesByCategory();
    }
  }
}
